import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import testid from '../../../services/testid-service';

import LoadingIndicator from '../../loading-indicator';
import style from './modal-body.less';

const ModalBody = ({ className = '', children, render, showLoading = false }) => {
  if (typeof render === 'function') {
    return render();
  }
  return (
    <div {...testid('modal-body')} className={classNames(style['modal-body'], className)}>
      {children}
      {showLoading && <LoadingIndicator className={style['loading-wrapper']} />}
    </div>
  );
};

ModalBody.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  render: PropTypes.func,
  showLoading: PropTypes.bool,
};

export default ModalBody;
